import { Box, Grid } from "@mui/material";
import { EnhancedCheckboxRHF, FieldLayout, IEnhancedDropDownItem, LabelPosition, RHookFormDatePicker } from "@websential/cosmic-v20";
import { FC, JSX, useCallback, useEffect, useState } from "react";
import Select, { GroupBase, OptionProps, components } from 'react-select'

import { IAppState } from "../../../../../store/reducers";
import { useSelector } from "react-redux";

interface IRoleAssignmentDetailPanel {
	activeUserRolesDetailData: any;
	selectedUserRolesDetail: any;
	formMethods: any;
	accountantAndClientsDDL: any;
}

// const updateSequence = (data: any[]) => {
// 	if (data) {
// 		// 1. Separate accountants and clients
// 		const accountants = data.filter(item => item.isAccountant);
// 		const clients = data.filter(item => !item.isAccountant);

// 		const result: any[] = [];

// 		// 2. For each accountant, push accountant + its clients
// 		accountants.forEach(accountant => {
// 			result.push(accountant);

// 			const relatedClients = clients.filter(
// 				client => client.accountantId === accountant.value
// 			);

// 			result.push(...relatedClients);
// 		});

// 		return result;
// 	}
// 	return []
// };

const updateSequence = (data: any[]) => {
	if (data) {
		// 1. Separate accountants and clients
		const accountants = data.filter(item => item.isAccountant);
		const clients = data.filter(item => !item.isAccountant);


		let result: any[] = [];

		// 2. For each accountant, push accountant + its clients
		if (accountants.length > 0) {
			accountants.forEach(accountant => {
				result.push(accountant);

				const relatedClients = clients.filter(
					client => client.accountantId === accountant.value
				);

				result.push(...relatedClients);
			});
		} else {
			result = clients
		}
		return result;

	}
	return []
};

export const RoleAssignmentDetailPanel: FC<IRoleAssignmentDetailPanel> = ({
	activeUserRolesDetailData,
	selectedUserRolesDetail,
	formMethods,
	accountantAndClientsDDL
}) => {
	const [seletedDefaultRole, setSeletedDefaultRole] = useState("")
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const assignedRolesToUsers = useSelector(
		(state: IAppState) => state.user.profile.roleId
	);
	const [userRolesDetailData, setUserRolesDetailData] = useState<any>(undefined)

	const getExpiresAtValue = (selectedRole?: any, role?: any) => {
		if (selectedRole?.expiresAt != null) return new Date(selectedRole.expiresAt);
		if (role?.expiresAt != null) return new Date(role.expiresAt);
		return null;
	};
	useEffect(() => {
		if (activeUserRolesDetailData && !selectedUserRolesDetail) {
			// alert(1)
			let updatedActiveUserRolesDetailData = activeUserRolesDetailData && activeUserRolesDetailData.rolesData && activeUserRolesDetailData.rolesData.length > 0 && activeUserRolesDetailData.rolesData.map((x: any) => ({
				...x,
				expiresAt: x.expiresAt && x.expiresAt !== null ? new Date(x.expiresAt) : x.expiresAt,
				checked: false
			}))
			activeUserRolesDetailData && activeUserRolesDetailData.rolesData && activeUserRolesDetailData.rolesData.length.length > 0 && activeUserRolesDetailData.rolesData.map((x: any) => {
				formMethods.setValue(`${x.value}-roleId`, false)
				formMethods.setValue(`${x.value}-expiresAt`, x.expiresAt && x.expiresAt !== null ? new Date(x.expiresAt) : x.expiresAt)
			})
			formMethods.setValue(`accountantClients`, [])
			setUserRolesDetailData(updatedActiveUserRolesDetailData)
		} else if (activeUserRolesDetailData && selectedUserRolesDetail) {
			// alert(2)
			if (selectedUserRolesDetail && selectedUserRolesDetail.rolesData && selectedUserRolesDetail.rolesData.length > 0) {
				// alert(0)
				const selectedMap = new Map(
					(selectedUserRolesDetail.rolesData || []).map((item: any) => [
						item.value,
						item
					])
				);

				console.log('selectedUserRolesDetail', selectedUserRolesDetail)
				console.log('activeUserRolesDetailData', activeUserRolesDetailData)


				const updatedActiveUserRolesDetailData = activeUserRolesDetailData && activeUserRolesDetailData.rolesData && activeUserRolesDetailData.rolesData.map(
					(role: any) => {
						const selectedRole: any = selectedMap.get(role.value);

						console.log('selectedRole', selectedRole)
						console.log('selectedRole.expiresAt', selectedRole && selectedRole.expiresAt)
						console.log('role.expiresAt', role && role.expiresAt)
						console.log('yooooooooooooooo', getExpiresAtValue(selectedRole, role))
						console.log('selectedRole?.expiresAt', selectedRole ? selectedRole.expiresAt : '(no selectedRole)');

						formMethods.setValue(`${role.value}-roleId`, Boolean(selectedRole))
						formMethods.setValue(`${role.value}-expiresAt`, getExpiresAtValue(selectedRole, role));
						return {
							...role,
							expiresAt: getExpiresAtValue(selectedRole, role),
							checked: Boolean(selectedRole)
						};
					}
				);
				setUserRolesDetailData(updatedActiveUserRolesDetailData);
			} else {
				// alert(3)
				let updatedActiveUserRolesDetailData = activeUserRolesDetailData && activeUserRolesDetailData.rolesData && activeUserRolesDetailData.rolesData.length > 0 && activeUserRolesDetailData.rolesData.map((x: any) => ({
					...x,
					expiresAt: x.expiresAt && x.expiresAt !== null ? new Date(x.expiresAt) : x.expiresAt,
					checked: false
				}))
				activeUserRolesDetailData && activeUserRolesDetailData.rolesData && activeUserRolesDetailData.rolesData.length > 0 && activeUserRolesDetailData.rolesData.map((x: any) => {
					formMethods.setValue(`${x.value}-roleId`, false)
					formMethods.setValue(`${x.value}-expiresAt`, x.expiresAt && x.expiresAt !== null ? new Date(x.expiresAt) : x.expiresAt)
				})
				setUserRolesDetailData(updatedActiveUserRolesDetailData)
			}
			formMethods.setValue(`accountantClients`, selectedUserRolesDetail.accountantClients)
		}
	}, [selectedUserRolesDetail, activeUserRolesDetailData])

	let roleData = [
		{
			label: "Super Admin",
			value: "6968c9d1949fe62caf456d77",
			expiresAt: "2026-01-20",
			checked: true
		},
		{
			label: "Admin",
			value: "6968f120949fe62caf458048",
			expiresAt: null,
			checked: false
		},
	]


	const items = [
		{
			label: "Zeeshan Acc",
			value: "zdfhdasfbrtsusrnfghd",
			isAccountant: true,
			accountantId: "12432134"
		},
		{
			label: "Qasim",
			value: "gfjhmn",
			isAccountant: false,
			accountantId: "12432134"
		},
		{
			label: "Umair",
			value: "dfb",
			isAccountant: false,
			accountantId: "12432134"
		},
		{
			label: "Bilal",
			value: "sdvbs",
			isAccountant: true,
			accountantId: "kjsdbvkjsbviuds"
		},
	]
	const formatGroupLabel = (data: any) => {
		// const isFirstChild = data.options && data.options.length > 0 && data.options[0].value === "earnings_audit";

		const groupStyles = {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			padding: 0,
			// margin: isFirstChild ? "-4px 0 0 0" : "-17px 0 -4px 0",
			color: "#000",
		};

		// useEffect(()=>{
		//   let selectedScreen = formMethods.getValues('screen')

		// },[])
		return (
			<div style={groupStyles}>
				<span style={{ textTransform: "capitalize" }}>
					<b>{data.label}</b>
				</span>

				{/* <span style={{backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center'}}>{data.options.length}</span> */}
			</div>
		)
	};
	// const customStyles = {
	// 	option: (provided: any, state: any) => ({
	// 		...provided,
	// 		fontSize: "13px",
	// 		margin: 0,
	// 		padding: "2px 2px 2px 2rem",
	// 	}),
	// 	control: (provided: any) => ({
	// 		...provided,
	// 		marginTop: "8px",
	// 	}),
	// 	singleValue: (provided: any) => ({
	// 		...provided,
	// 		fontSize: "13px",
	// 	}),
	// };
	const color = "#0091b3";

	const customStyles = {
		control: (provided: any, state: { isDisabled: any; }) => {
			return ({
				...provided,
				backgroundColor: state.isDisabled ? 'rgba(0, 0, 0, 0.06)' : '#fff',
				borderColor: '#c3c4c4',
				minHeight: '3em',
				borderRadius: "2px !important",
				// height: '3em',
				// boxShadow: state.isFocused ? null : null,
				":hover": {
					borderColor: '#000'
				},
			})
		},
		container: (provided: any) => ({
			...provided,
			fontFamily: ["Roboto", "sans-serif"].join(","),
			fontSize: ".8125rem",
			fontWeight: 500,
			lineHeight: "1rem",
		}),
		multiValue: (styles: any) => {
			return {
				...styles,
				backgroundColor: "#deebff",
			};
		},
		multiValueLabel: (styles: any) => ({
			...styles,
			color: color,
			fontSize: "16px",
		}),
		multiValueRemove: (styles: any) => ({
			...styles,
			color: color,
			":hover": {
				backgroundColor: "#d8e6fb",
				color: color,
			},
		}),
	};
	const getItems = (
		options: any[],
		isEmpty?: Boolean,
		multiEnable?: Boolean
	) => {
		if (
			isEmpty &&
			options &&
			options.length > 0 &&
			options[0].value !== "" &&
			!multiEnable
		) {
			let emptyOption = { value: "", label: "--" };
			options.splice(0, 0, emptyOption);
		}
		options && options.map((item, index) => ({
			index: item.value,
			value: {
				...item,
				toString: () => index, // assumes item has a unique id property
			},
			label: item.label,
		}));
		return options;
	};

	const getMultiSelected = (options: IEnhancedDropDownItem[] | any) => {
		let arr: IEnhancedDropDownItem[] = [];
		options.forEach((option: any) => {
			// for (let i in selectedItem) {
			// 	if (option && option.value === selectedItem[i]) {
			// 		arr.push(option);
			// 	}
			// }
		});
		return arr;
	};

	const Option = (props: JSX.IntrinsicAttributes & OptionProps<unknown, boolean, GroupBase<unknown>> | any) => {

		return (
			<div>
				<components.Option {...props}>
					{props.label !== "--" && props.data.isAccountant ? (
						<>
							<input
								type="checkbox"
								checked={props.isSelected}
								onChange={() => null}
								style={{ accentColor: "#0091b3", fontWeight: "bold" }}
								disabled={seletedDefaultRole === "Admin" ? true : false}
							/>{" "}
						</>
					) : props.label !== "--" && !props.data.isAccountant && (
						<>
							<input
								type="checkbox"
								checked={props.isSelected}
								onChange={() => null}
								style={{ accentColor: "#0091b3", marginLeft: "2rem" }}
								disabled={seletedDefaultRole === "Accounting Professional" ? true : false}
							/>{" "}
						</>
					)}
					<label style={{ fontWeight: props.data.isAccountant ? "bold" : "normal" }}>{props.label}</label>
				</components.Option>
			</div>
		);
	};

	const selectedClients = formMethods.watch("accountantClients") || [];
	const onClientSelectionChangeHandler = (nextSelected: any[]) => {
		const prevSelected = formMethods.getValues("accountantClients") || [];

		// item that was just added
		const addedItem = nextSelected.find(
			(item) => !prevSelected.some((p: any) => p.value === item.value)
		);

		let updatedSelection = [...nextSelected];

		// ONLY when a CLIENT is added
		if (addedItem && addedItem.isAccountant === false) {
			updatedSelection = nextSelected.filter(
				(item) =>
					!(
						item.isAccountant === true &&
						item.accountantId === addedItem.accountantId
					)
			);
		}

		formMethods.setValue("accountantClients", updatedSelection, {
			shouldDirty: true,
			shouldValidate: true,
		});
	};


	const onRoleSelectionChangeHandler = useCallback((selectedRoleId: string, selectedRoleLabel: string, value: any) => {
		// alert("dev    " + value + "   hai")
		if (isAdminUser !== 500) {
			let assignedRolesIds = assignedRolesToUsers.map((x: any) => x.roleId)
			let isSelectedRoleAssinged = assignedRolesIds.includes(selectedRoleId)
			if (isSelectedRoleAssinged && selectedRoleLabel === "Accounting Professional" && value) {
				setSeletedDefaultRole("Accounting Professional")

				let updatedActiveUserRolesDetailData = userRolesDetailData.map((x: any) => ({
					...x,
					expiresAt: x.expiresAt && x.expiresAt !== null ? new Date(x.expiresAt) : x.expiresAt,
					checked: x.label === "Admin" ? true : x.label === "Accounting Professional" ? true : x.checked
				}))
				userRolesDetailData.map((x: any) => {
					const [checkBox] = formMethods.watch([`${x.value}-roleId`]);
					formMethods.setValue(`${x.value}-roleId`, x.label === "Admin" ? true : x.label === "Accounting Professional" ? true : checkBox)
					formMethods.setValue(`${x.value}-expiresAt`, x.expiresAt && x.expiresAt !== null ? new Date(x.expiresAt) : x.expiresAt)
				})
				formMethods.setValue(`accountantClients`, [])
				setUserRolesDetailData(updatedActiveUserRolesDetailData)
			} else if (isSelectedRoleAssinged && selectedRoleLabel === "Accounting Professional" && !value) {
				let defaultAdminRole = userRolesDetailData.find((x: any) => x.label === "Admin")
				const [selectedAdminRole] = formMethods.watch([`${defaultAdminRole.value}-roleId`]);
				if (selectedAdminRole) {
					setSeletedDefaultRole("Admin")
					formMethods.setValue(`accountantClients`, [])
				} else {
					setSeletedDefaultRole("")
				}
			} else if (isSelectedRoleAssinged && selectedRoleLabel === "Admin" && value) {
				setSeletedDefaultRole("Admin")
				formMethods.setValue(`accountantClients`, [])
			} else if (isSelectedRoleAssinged && selectedRoleLabel === "Admin" && !value) {
				let defaultAccountingProfessionalRole = userRolesDetailData.find((x: any) => x.label === "Accounting Professional")
				const [selectedAccountingProfessionalRole] = formMethods.watch([
					`${defaultAccountingProfessionalRole.value}-roleId`
				]);
				if (selectedAccountingProfessionalRole) {
					setSeletedDefaultRole("Accounting Professional")
					formMethods.setValue(`accountantClients`, [])
				} else {
					setSeletedDefaultRole("")
				}
			} else {
				let defaultAccountingProfessionalRole = userRolesDetailData.find((x: any) => x.label === "Accounting Professional")
				let defaultAdminRole = userRolesDetailData.find((x: any) => x.label === "Admin")

				const [selectedAccountingProfessionalRole, selectedAdminRole] = formMethods.watch([
					`${defaultAccountingProfessionalRole.value}-roleId`,
					`${defaultAdminRole.value}-roleId`
				]);

				if (selectedAccountingProfessionalRole) {
					formMethods.setValue(`accountantClients`, [])
					setSeletedDefaultRole("Accounting Professional")
				} else if (selectedAdminRole) {
					setSeletedDefaultRole("Admin")
					formMethods.setValue(`accountantClients`, [])
				} else {
					setSeletedDefaultRole("")
				}
			}
		} else {
			setSeletedDefaultRole("")
		}
	}, [userRolesDetailData])




	// when default accounting professional is selected admin would be disabled 
	const defaultAccountingProfessionalRole = userRolesDetailData?.find(
		(x: any) => x.label === "Accounting Professional"
	);

	const isAccountingProfessionalSelected = defaultAccountingProfessionalRole
		? formMethods.watch(`${defaultAccountingProfessionalRole.value}-roleId`)
		: false;


	return (
		<>
			{userRolesDetailData && userRolesDetailData.length && <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
				sx={{
					color: "#4b5563",
					fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
					fontSize: ".875rem"
				}}>
				Select Role
			</Grid>}
			{userRolesDetailData &&
				userRolesDetailData.sort((a: any, b: any) => a.label.localeCompare(b.label)).map((item: any) => {
					return (
						<Grid container size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ alignItems: "center" }}>
							<Grid size={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}></Grid>
							<Grid size={{ xl: 3, lg: 3, md: 3, sm: 4, xs: 4 }} sx={{ "& .MuiFormControlLabel-root": { marginBottom: "0!important" } }}>
								<EnhancedCheckboxRHF
									name={`${item.value}-roleId`}
									checked={item.checked}
									testId="role"
									checkboxLabel={item.label}
									onSelectionChangeHandler={(check: any) => onRoleSelectionChangeHandler(item.value, item.label, check)}
									readOnly={
										item.label === "Admin" && isAccountingProfessionalSelected ? true : false
									}
								/>
							</Grid>
							<Grid size={{ xl: 7, lg: 7, md: 7, sm: 6, xs: 6 }} sx={{
								"& .calenderWrapper ": {
									marginBottom: "20px!important",
									maxWidth: "178px!important"
									// fontSize: ".875rem" 
								}
							}}>
								<RHookFormDatePicker
									name={`${item.value}-expiresAt`}
									testId="role-date"
									label="Exp. Date"
									format="M dd, yy"

									defaultValue={item.expiresAt && item.expiresAt ? new Date(item.expiresAt) : null}
								/>
							</Grid>

						</Grid>
					);
				})}
			<Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}>
				<FieldLayout
					label="Clients"
					testId=""
					labelPosition={LabelPosition.Left}
					labelColumns={4}
					fieldColumns={8}
				>
					<Select
						id="accountantClients"
						{...formMethods.register("accountantClients")}
						onChange={onClientSelectionChangeHandler}
						// options={groupedOptions}
						options={getItems(updateSequence(accountantAndClientsDDL))}
						closeMenuOnSelect={false}
						// value={getMultiSelected(groupedOptions)}
						// formatGroupLabel={formatGroupLabel}
						value={selectedClients}
						styles={customStyles}
						isMulti={true}
						isOptionDisabled={(option: any) => {
							if (seletedDefaultRole === "Admin") {
								return option.isAccountant === true;
							}

							if (seletedDefaultRole === "Accounting Professional") {
								return option.isAccountant === false;
							}

							return false;
						}}
						hideSelectedOptions={false}
						components={{
							Option,
							IndicatorSeparator: () => null,
						}}
					/>
				</FieldLayout>
			</Grid>
		</>
	);
};
